// extracted by mini-css-extract-plugin
export var container = "_ek-1";
export var cornerButtonContainer = "_ek-6";
export var disabled = "_ek-2";
export var dragActive = "_ek-3";
export var fileContainer = "_ek-5";
export var hiddenInput = "_ek-4";
export var widthContainer = "_ek-0";